import React from 'react';
import { Views } from 'react-big-calendar';
import { CalendarEventsPeriod } from '@trnsact/trnsact-shared-types';

import { CalendarMapper } from '../../mapper';
import { CalendarView, CalendarViewComponentProps } from '../../types';
import { Calendar, CalendarConnector, CalendarEventCard } from '../calendar';

export const WeekCalendar = ({ date, onNavigate }: CalendarViewComponentProps) => (
  <CalendarConnector
    period={CalendarEventsPeriod.Week}
    dateRange={CalendarMapper.getVisibleRange(CalendarView.Week, date)}
    children={props => (
      <Calendar
        step={10}
        date={date}
        timeslots={6}
        view={Views.WEEK}
        views={[Views.WEEK]}
        onNavigate={onNavigate}
        components={{
          event: props => <CalendarEventCard showMore {...props} />,
        }}
        {...props}
      />
    )}
  />
);
